import {observer} from 'mobx-react-lite'
import TeamsInfo from '../TeamsInfo'

const CompanyTeams = () => {
  return (
    <TeamsInfo />
  )
}

export default observer(CompanyTeams)